import { useState } from "react";
import { faqs } from "../data";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="wrap max-w-3xl">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
            <span className="font-poster">07</span>
            <span className="h-3 w-px bg-current opacity-40" />
            <span>常见问答</span>
          </span>
          <h2 className="eyebrow mt-4 text-2xl font-black text-foreground-950 md:text-3xl">
            关于吃瓜91，你可能还想问
          </h2>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="eyebrow text-base font-bold text-foreground-950">{f.q}</span>
                  <span
                    className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all ${
                      isOpen ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className="ri-add-line h-4 w-4 flex items-center justify-center" />
                  </span>
                </button>
                {isOpen && (
                  <div className="faq-open border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}